import React from "react";
import style from "../../css/homepage/Benifitinvesting.module.css";

const Benifitinvesting = () => {
    return (
        <div className={`container-fluid ${style.investing_container}`}>
            <div className="container py-5">
                <h2 className="text-center mb-4 fw-bold"   style={{ color: "var(--tittle-text)" }} >WHY TO JOIN MISSION 4000</h2>
                <div className="row g-4">
                    {cardData.map((card, index) => (
                        <div className="col-md-6 col-lg-6"  style={{ color: "var(--tittle-text)" }}key={index}>
                            <div className={`${style.card} shadow-lg rounded-4 p-4 h-100 d-flex flex-column justify-content-between `}  style={{ color: "var(--tittle-text)" }}> 
                                <div className="d-flex align-items-center mb-3">
                                    <i className={`fa-solid ${card.icon} me-2 fs-4 `}  style={{ color: "var(--tittle-text)" }}></i>
                                    <h5 className="fw-bold mb-0 "  style={{ color: "var(--tittle-text)" }}>{card.title}</h5>
                                </div>
                                <p  style={{ color: "var(--tittle-text)" }}>{card.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const cardData = [
    {
        icon: "fa-chart-line",
        title: "ALGO DRIVEN SWING SETUPS",
        text: "Learn actual money-making setups that work in the Indian market."
    },
    {
        icon: "fa-bullseye",
        title: "AI BASED FUNDAMENTAL",
        text: "Most crucial fundamental checklist for quality stock selection."
    },
    {
        icon: "fa-solid fa-magnifying-glass-chart",
        title: "ALGO SCANNER",
        text: "Get ready-made stocks without wasting time screening them."
    },
    {
        icon: "fa-solid fa-shield",
        title: "mission 4000",
        text: " Join us and get a chance to come in premium trading community."
    }
];

export default Benifitinvesting;